"use client";
import React, { useState, useEffect, useRef } from "react";
import Head from "next/head";
import {
  Container,
  Divider,
  Grid,
  GridRow,
  GridColumn,
  Image,
  Icon,
} from "semantic-ui-react";
import Layout from "../../../../container";
import PlacesAutocomplete from "react-places-autocomplete";
import {
  formattedCityName,
  getCitiesForRegion,
} from "../../../../common/Utils";
import NhRankingSearchSuggestion from "../../../../components/NhRankingSearchSuggestion";
import MapTabs from "../../../../components/MapTabs";
import ViewToggle from "../../../../components/ViewToggle";
import CityrankingList from "../../CityrankingList";
import { getDetailsNhboundrieslist } from "../../../../modules/Graphql/neighborhoodboundriesgraphql";
import getCityInfo from "../../CityInfo";
import SearchBar from "../../../Nhranking/component/SearchBar";

var localStorage = require("localStorage");

let recordCount = 0;

function separateCountryName(location) {
  if (!location) {
    return "";
  }
  let country_name = location.replace(/-/g, " ");
  return country_name;
}

const Cityranking = () => {
  const [activePage, setActivePage] = useState(1);
  const [cityname, setCityname] = useState("");
  const [datamsg, setDatamsg] = useState("Loading...");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emptyRecords, setEmptyRecords] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [gmapsLoaded, setGmapsLoaded] = useState(false);
  const [results, setResults] = useState([]);
  const [selectedfilter, setSelectedFilter] = useState("Safety Score");
  const [filterval, setFilterVal] = useState("crime");

  const scrollerRef = useRef();

  const initMapdata = () => {
    setGmapsLoaded(true);
  };

  const togglePrev = (e, { value }, id) => {
    setActivePage(value.activePage);
  };

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 767);
  };

  const handleNhRankingSearchSuggestion = (location) => {
    window.location.href = `/Cityranking/best-overall/${location.cityUrl}`;
  };

  const handlesummaryClick = (id) => {
    window.location.replace("/City/" + id);
  };

  const handleTabChange = (value, displayText, urlText) => {
    const slug = window.location.href;
    const parts = slug.split("/");
    const pageurl = parts[parts.length - 2];
    window.location.href = `/Cityranking/${urlText}/${pageurl}`;
  };

  const getOrderByValue = (filterValue) => {
    const filterMap = {
      npi: "npiscore_city",
      school: "schoolscore_city",
      crime: "crimescore_city",
      medianprice: "medianpricescore_city",
      value: "valuescore_city",
      appreciation: "appreciation_city",
    };

    return filterMap[filterValue] || "npiscore_city";
  };

  const handleViewChange = (view) => {
    if (view !== "Top Lists") {
      localStorage.setItem("ispagemain", true);
      localStorage.setItem("selectdnhranking", filterval);
      window.open(`/?address=${cityname}, CA, USA`);
    }
  };

  const getCityranking = (count, filter) => {
    setLoading(true);
    const slug = window.location.href;
    const parts = slug.split("/");
    const pageurl = parts[parts.length - 2];
    const city_name = separateCountryName(pageurl);
    setCityname(city_name);

    let dataArr = [];
    setUserInput(city_name);
    const getcounties = getCitiesForRegion(city_name);
    let filterBy = "postalcity_name";
    let operateBy = "=";
    let filtervalue = city_name;
    let filterfields = [
      {
        name: "county_name",
        value: city_name,
        operator: "=",
      },
      { name: "postalcity_name", value: "", operator: "!=" },
    ];
    if (getcounties !== "") {
      filterBy = "postalcity_name";
      operateBy = "IN";
      filtervalue = getcounties;
      filterfields = [
        {
          name: filterBy,
          value: filtervalue,
          operator: operateBy,
        },
      ];
    }

    var getdata = {
      start: count,
      limit: 300,
      order:
        filter === "medianprice" ||
        filter === "value" ||
        filter === "appreciation"
          ? "ASC"
          : "DESC",
      orderBy: getOrderByValue(filter),
      fields: filterfields,
      userId: "cityranking",
    };

    getDetailsNhboundrieslist(getdata)
      .then((result) => {
        if (
          result &&
          result.data.getDetailsNhBoundries &&
          result.data.getDetailsNhBoundries.length > 0
        ) {
          let datanh = result.data.getDetailsNhBoundries;
          setDatamsg("");
          setItems((prevItems) => prevItems.concat(datanh));
          setLoading(false);
        } else if (
          result &&
          result.data.getDetailsNhBoundries &&
          result.data.getDetailsNhBoundries.length === 0 &&
          items.length === 0
        ) {
          setDatamsg("No data found");
          setLoading(false);
        } else {
          setDatamsg("No data found");
          setEmptyRecords(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        setDatamsg("Something went wrong, please try again");
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    getCityranking(recordCount, filterval);
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    setTimeout(() => initMapdata(), 1500);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  let selectedCityInfo = getCityInfo(selectedfilter, cityname);

  return (
    <Layout>
      <Container fluid style={{ padding: "0em 5em 5em" }}>
        <Head>
          <meta charSet="UTF-8" />
          <title>
            City Ranking: {cityname !== "" ? "-" + cityname : ""} County's Top
            Cities
          </title>
          <meta
            name="description"
            content={`Find out which cities in ${
              cityname ? "-" + cityname : ""
            } County rank highest for schools, safety, amenities, and best value.`}
          />
          <meta
            name="keywords"
            content={`${cityname ? "-" + cityname : ""} County, city rankings, best cities, neighborhood comparison, schools, safety`}
          ></meta>
          <meta
            property="og:image"
            content={
              process.env.NEXT_PUBLIC_CDN_ID + "static/images/seoimg.png"
            }
          />
        </Head>
        <div className="homeaccount_main common_contain_main">
          <div className="homeaccont_main_content">
            <Grid>
              <GridRow className="row-grid-ui">
                <GridColumn mobile={16} tablet={16} computer={14}>
                  <div className="nhranking_main">
                    <h2 className="NhrankingTitles">
                      2025 Top Cities by Overall Score in:
                    </h2>
                    <div className="search_welcome_main">
                      {gmapsLoaded === false && (
                        <div>
                          <div className="ui input" style={{ width: "100%" }}>
                            <div
                              className="ui large left icon input location-search-input"
                              style={{ width: "100%" }}
                            >
                              <input
                                type="text"
                                icon="search"
                                iconposition="left"
                                style={{
                                  width: "100%",
                                  borderRadius: "0px",
                                  fontSize: "15px",
                                  fontWeight: "bold",
                                }}
                                size="large"
                                placeholder="Enter city"
                                className="location-search-input"
                              />
                              <i aria-hidden="true" className="search icon"></i>
                            </div>
                          </div>
                        </div>
                      )}
                      {gmapsLoaded && (
                        <SearchBar
                          value={userInput}
                          onChange={(val) => setUserInput(val)}
                          onKeyDown={() => {}}
                          onSelect={(val) => setUserInput(val)}
                          showSuggestions={results}
                          rankingType="safety"
                          page="cityranking"
                        />
                      )}
                    </div>
                    <NhRankingSearchSuggestion
                      onSelect={handleNhRankingSearchSuggestion}
                      ispage="cityranking"
                    />
                  </div>
                </GridColumn>
              </GridRow>
            </Grid>

            <Divider />
          </div>
          <div className="city_ranking_inner">
            <MapTabs onChange={handleTabChange} defaultactiveTab="crime" />
            <ViewToggle
              onToggle={handleViewChange}
              defaultSelected="Top Lists"
            />
            <div>
              <div className="nhranking_top_description">
                <p>{selectedCityInfo}</p>
                <Divider />
              </div>
              <CityrankingList
                itemData={items}
                prev={togglePrev}
                active={activePage}
                id="neighborhoods"
                datamsg={datamsg}
                scollerClassName="scroller"
                ref={scrollerRef}
                // onScroll={handleScroll}
                loading={loading}
                isMobile={isMobile}
                handlesummaryClick={handlesummaryClick}
              />
            </div>
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default Cityranking;
